var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7302ac063054d55554b607f5c11767e318aa8e4b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby@homepl"]={id:"7302ac063054d55554b607f5c11767e318aa8e4b"};
      